import { render, staticRenderFns } from "./CheckoutOffersCard.vue?vue&type=template&id=0766f47a&scoped=true&lang=pug&"
import script from "./CheckoutOffersCard.vue?vue&type=script&lang=js&"
export * from "./CheckoutOffersCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutOffersCard.vue?vue&type=style&index=0&id=0766f47a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0766f47a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow,VSkeletonLoader,VSpacer})
